import OnboardingGuide from "@/components/onboarding/OnboardingGuide";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";

const OnboardingPage = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      
      <div className="pt-24 pb-16 px-4 sm:px-6 lg:px-8">
        <OnboardingGuide />
      </div>

      <Footer />
    </div>
  );
};

export default OnboardingPage;